import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class GeneralInformation extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from General Information</h1>
      </div>
    );
  }
}

export default GeneralInformation;